/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const  getGrupoAcessoSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}

